import type { RootState } from '~/store/store.ts';

export const selectIITHashes = (state: RootState) => state.iit.IITHashes;
export const selectIIT = (state: RootState) => state.iit;
export const selectIITLoading = (state: RootState) => state.iit?.isLoading || {};
export const selectIITError = (state: RootState) => state.iit?.error;
